/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tampilan_NInputs */

const en_tut_tampilan_n = /** @type {(inputs: Tut_Tampilan_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appearance is stored in the browser you are using and applies to every workspace in that browser — it is not a setting forced on the whole team.`)
};

const id_tut_tampilan_n = /** @type {(inputs: Tut_Tampilan_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilihan tampilan disimpan di browser yang Anda pakai dan berlaku untuk semua workspace di browser itu — bukan setelan yang dipaksakan ke seluruh tim.`)
};

/**
* | output |
* | --- |
* | "Appearance is stored in the browser you are using and applies to every workspace in that browser — it is not a setting forced on the whole team." |
*
* @param {Tut_Tampilan_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tampilan_n = /** @type {((inputs?: Tut_Tampilan_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tampilan_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tampilan_n(inputs)
	return en_tut_tampilan_n(inputs)
});